import { z } from 'zod';

export enum Product {
    SellersDirect = 'sellers direct',
    Compass = 'compass',
    ClientsDirect = 'clients direct',
    PickleLeads = 'pickle leads'
}

export const ProductSchema = z.nativeEnum(Product);